const handlers: Array<{ token: symbol; onBack: () => void }> = [];

/** Modal drawers consume Android Back before the underlying page does. */
export function registerNativeModalBack(onBack: () => void) {
  const token = Symbol("native-modal-back");
  handlers.push({ token, onBack });
  return () => {
    const index = handlers.findIndex((handler) => handler.token === token);
    if (index !== -1) handlers.splice(index, 1);
  };
}

export function consumeNativeModalBack() {
  const handler = handlers.at(-1);
  if (!handler) return false;
  handler.onBack();
  return true;
}
